import LogoUS from "../../assets/WebpImages/aliffarms-usa.webp";
import LogoPk from '.././../assets/WebpImages/aliffarms-pk.webp'
import { useUser } from "../../context/useUser";
import { useNavigate } from "react-router-dom";
import { SECRET_KEY } from "../../constant";
import USFlag from '.././../assets/WebpImages/american-flag.webp'
import PakFlag from '.././../assets/WebpImages/pak-flag.webp'
import MeatBg from '.././../assets/images/meat.avif'

const encryptData = (data) => {
  let encoded = btoa(data + SECRET_KEY);
  return encoded.split("").reverse().join("");
};

function CountryVersion() {
  const { setCountry } = useUser();
  const navigate = useNavigate();

  const handleSelectCountry = (countryCode) => {
    const encryptedRegion = encryptData(countryCode);
    const expiryTime = Date.now() + 7 * 24 * 60 * 60 * 1000;
    localStorage.setItem("region", encryptedRegion);
    localStorage.setItem("regionExpiry", expiryTime);
    setCountry(countryCode);
    navigate(`/?region=${countryCode}`);
  };

  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Background Image with Dark Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${MeatBg})` }}
      />
      <div className="absolute inset-0 bg-black opacity-50"></div>

      {/* Content Wrapper */}
      <div className="relative flex flex-col min-h-screen text-gray-100">
        {/* Header with fixed height */}
        <div className="flex justify-between items-center px-8 py-4 md:h-[100px] relative z-10">
          <img src={LogoUS} alt="America Logo" className="h-[70px] md:h-[80px]" />
          <img src={LogoPk} alt="Pakistan Logo" className="h-[100px] md:h-[120px]" />
        </div>

        {/* Content Section */}
        <div className="flex-1 flex flex-col justify-center items-center text-center px-4 relative z-10">
          {/* Intro Text */}
          <h1 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg">
            Welcome to Alif Farms
          </h1>
          <p className="mt-4 text-lg md:text-xl text-gray-300">
            Explore our collection and start shopping today.
          </p>

          {/* Flag & Button Section */}
          <div className="flex w-full justify-center max-w-[1200px] gap-8 mt-16">
            {/* US Section */}
            <div className="flex-1 flex flex-col justify-center items-center rounded-2xl">
              <img src={USFlag} alt="US Flag" className="w-[250px] h-[150px] md:w-[350px] md:h-[200px] object-cover rounded-md shadow-md" />
              <button
                className="mt-6 bg-[#0f1417] text-white px-8 py-3 rounded-lg text-lg font-semibold shadow-md transform transition-all hover:scale-105 hover:shadow-lg"
                onClick={() => handleSelectCountry("US")}
              >
                Order Now
              </button>
            </div>

            {/* Pakistan Section */}
            <div className="flex-1 flex flex-col justify-center items-center rounded-2xl">
              <img src={PakFlag} alt="Pakistan Flag" className="w-[250px] h-[150px] md:w-[350px] md:h-[200px] object-cover rounded-md shadow-md" />
              <button
                className="mt-6 bg-[#0f1417] text-white px-8 py-3 rounded-lg text-lg font-semibold shadow-md transform transition-all hover:scale-105 hover:shadow-lg"
                onClick={() => handleSelectCountry("PK")}
              >
                Order Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}

export default CountryVersion;
